'use client';
import type { HTMLAttributes } from 'react';
import { forwardRef, useRef } from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';
import { useListenStickyElement } from '../../hooks/use-listen-sticky-element';
import { ResponsiveValues } from '@wwe-portal/ui/hooks/use-responsive-value';

export interface StickyTopMenuProps extends HTMLAttributes<HTMLDivElement> {
  fluid?: boolean;
  offset?: ResponsiveValues<number>;
}

export const StickyTopMenu = forwardRef<HTMLDivElement, StickyTopMenuProps>(
  (
    { className, children, fluid = true, offset, ...props },
    stickyElementRef
  ) => {
    const internalRef = useRef<HTMLDivElement>(null);
    const ref = stickyElementRef ?? internalRef;

    useListenStickyElement(
      ref,
      (value) => {
        if (typeof ref !== 'object' || ref.current == null) return;
        ref.current.setAttribute('data-sticky', String(value));
      },
      {
        offset,
      }
    );

    return (
      <div
        className={cn(
          'z-sticky data-[sticky=true]:bg-back600 sticky top-[60px] pb-4 pt-2 xl:top-[70px]',
          {
            '-mx-5 xl:-mx-[30px]': fluid,
          },
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </div>
    );
  }
);

StickyTopMenu.displayName = 'StickyTopMenu';
